module.exports = __webpack_public_path__ + "static/media/02.7406c940.jpg";